<app-audit-subbar></app-audit-subbar>
<app-audit-category sectionKey="technical"></app-audit-category>
<app-diagnostic></app-diagnostic>
